import { useContext } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png'
import { MdClose, MdDashboard, MdHome, MdOutlineAnalytics, MdOutlineDashboard, MdOutlinePayment, MdOutlinePayments, MdOutlineSpaceDashboard, MdPayments, MdSubject } from "react-icons/md";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { GoPerson } from "react-icons/go";


export default function SideBar(props) {

  const appContext = useContext(AppContext);

  function openSideBar() {
    appContext.setIsSideBarOpen(true);
  }

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({
      item,
    })

    if(appContext.isSideBarOpen) {
      closeSideBar();
    } else {
      //..
    }
  }

  return (
    <div
      className="SideBar mShadow2"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar">

        
        <h6 
          className="text-end"
          onClick={appContext.closeSideBar}
        >
          <MdClose 
            size={32}
            style={{
              cursor: "pointer"
            }}
          />
        </h6>

        <div
          className="logo-holder"
        >
          <img
            src={logo}
            
          />
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("home")
          }}
          data-active={(!appContext.navItem || appContext.navItem === 'home')}
        >
          <p className="text">Home</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("about_us")
          }}
          data-active={(appContext.navItem === 'about_us')}
        >
          <p className="text">About Us</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("services")
          }}
          data-active={(appContext.navItem === 'services')}
        >
          <p className="text">Products & Services</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("gallery")
          }}
          data-active={(appContext.navItem === 'gallery')}
        >
          <p className="text">Gallery</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("projects")
          }}
          data-active={(appContext.navItem === 'projects')}
        >
          <p className="text">Projects</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("staff")
          }}
          data-active={(appContext.navItem === 'staff')}
        >
          <p className="text">Staff</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            goTo("contact_us")
          }}
          data-active={(appContext.navItem === 'contact_us')}
        >
          <p className="text">Contact Us</p>
        </div>

        

      </div>
    </div>
  )
}